module.exports = __webpack_public_path__ + "img/main_pic.c127eba7.svg";